// 🚀 V2版本 - 基于SQLite数据库的词汇检查器
// 解决内存泄漏问题：从1.5GB降到~100KB

// 导出兼容层，保持API一致性
export { vocabularyLevelChecker, vocabularyCompatibility } from './compatibility-layer';

// 导出管理器
export { vocabularyLevelManager } from './manager';

// 词汇难度级别枚举
export enum WordDifficultyLevel {
  UNKNOWN = -1,
  BASIC = 0,
  INTERMEDIATE = 1,
  ADVANCED = 2,
  EXPERT = 3
}
